/**
 * FunctionsHttpError exposes the upstream JSON body via `.context.json()`.
 * Surface the function's `error` code, appending `detail` when present so a
 * merchant sees actionable text (OpenAI billing/verification messages).
 *
 * Partagé par tous les repositories qui invoquent une Edge Function : le code
 * d'erreur remonté est ce que l'UI traduit, donc il ne doit exister qu'UNE
 * façon de le décapsuler.
 */
export async function functionError(error: unknown, fallback: string): Promise<Error> {
  let code = fallback;
  let detail: string | undefined;
  try {
    const ctx = (error as { context?: { json?: () => Promise<{ error?: string; detail?: string }> } }).context;
    if (ctx?.json) {
      const body = await ctx.json();
      if (body?.error) code = body.error;
      if (body?.detail) detail = body.detail;
    } else if (error && typeof error === 'object' && 'message' in error) {
      code = String((error as { message: string }).message);
    }
  } catch {
    /* keep fallback */
  }
  const err = new Error(detail ? `${code}: ${detail}` : code);
  (err as Error & { code?: string }).code = code;
  return err;
}
